export interface AgeVerificationDialogResult {
  ageConfirmation: boolean;
  actionName?: string;
  params?: any;
}